import React from 'react';
import { useFromAssets } from '../../context/assets.js';
import useFromAsset from '../../hooks/use-from-asset.js';
import useFromWalletAccount from '../../hooks/use-from-wallet-account.js';
import useToAsset from '../../hooks/use-to-asset.js';
import useResetForm from '../../hooks/use-reset-form.js';
import useTrackAssetConfigureEvent from '../../hooks/analytics/use-track-configure-asset.js';
const FromAsset = ({ Component, className, style, onPress }) => {
    const [fromAsset, setFromAsset] = useFromAsset();
    const [toAsset, setToAsset] = useToAsset();
    const resetForm = useResetForm();
    const [fromWalletAccount] = useFromWalletAccount();
    const availableFromAssets = useFromAssets();
    const trackAssetConfigureSwap = useTrackAssetConfigureEvent();
    const handlePress = async () => {
        const asset = await onPress?.({
            side: 'from',
            walletAccount: fromWalletAccount.toString(),
            assets: availableFromAssets.value ?? [],
        });
        if (!asset)
            return;
        void trackAssetConfigureSwap();
        const currentFromAsset = fromAsset;
        resetForm();
        setFromAsset(asset.name);
        if (toAsset.name === asset.name) {
            setToAsset(currentFromAsset);
        }
    };
    const loading = availableFromAssets.loading;
    if (Component) {
        return (React.createElement(Component, { side: "from", asset: fromAsset, loading: loading, className: className, style: style, onPress: handlePress }));
    }
    return null;
};
export default FromAsset;
